export const iban = (iban: string): string => {
  const cleanInput = iban.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
  return cleanInput.replace(/(.{4})/g, '$1 ').trim()
}

export const IBAN_MAX_LENGTH = 34
